(function () {

    'use strict';

    angular.module('Services').service('AccountingCustomerBillingShipmentsTableService', AccountingCustomerBillingShipmentsTableService);

    AccountingCustomerBillingShipmentsTableService.$inject = [
        '$filter',
        'TableLiteFactory',
        'toastr',
        'AccountingService',
        '$routeParams'
    ];

    function AccountingCustomerBillingShipmentsTableService(
        $filter,
        TableLiteFactory,
        toastr,
        AccountingService,
        $routeParams,
    ) {
        return function () {
            const customerBillingId = $routeParams.id;

            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: true,
                    noFooter: false,
                    noTopOptions: false,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Date of Booking',
                        viewName: 'bookingDate'
                    },
                    {
                        label: 'Consignment No',
                        viewName: 'consignmentId'
                    },
                    {
                        label: 'Carrier',
                        viewName: 'carrierName'
                    },
                    {
                        label: 'Service Type',
                        viewName: 'serviceType'
                    },
                    {
                        label: 'No. of Packages',
                        viewName: 'noOfPackages'
                    },
                    {
                        label: 'Declared Weight',
                        viewName: 'totalChargeableWeight'
                    },
                    {
                        label: 'Charge Weight',
                        viewName: 'chargeableWeight'
                    },
                    {
                        label: 'Price Ex. Tax',
                        viewName: 'priceExTax'
                    },
                    {
                        label: 'Tax',
                        viewName: 'priceTax'
                    },
                    {
                        label: 'Total',
                        viewName: 'priceTotal'
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
            serviceCallback: AccountingService.CustomerBilling.getShipments,
                paramId: customerBillingId,
                callbackFormat: ['id', 'success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row) {
                    let packages = 0;
                    let kgCharge = 0;
                    row.packages.forEach(packageTemp => {
                        packages += packageTemp.quantity;
                        kgCharge += packageTemp.weight * packageTemp.quantity;
                    });
                    row.bookingDate = row.bookingDate ? $filter('bbaDate')(row.bookingDate) : 'N/A';
                    row.consignmentId = row.consignmentId || 'N/A';
                    row.carrierName = row.carrierProfile && row.carrierProfile.name || 'N/A';
                    row.serviceType = row.serviceProfile && row.serviceProfile.name || 'N/A';
                    row.noOfPackages = packages;
                    row.kgCharge = kgCharge;
                    row.chargeableWeight = row.invoiceDetails.chargeableWeight
                    row.priceExTax = $filter('bbaCurrency')(row.amount || 0);
                    row.priceTax = $filter('bbaCurrency')(row.shippingCost.taxes || 0);
                    row.priceTotal = $filter('bbaCurrency')(((row.amount || 0) + (row.shippingCost.taxes || 0)) || 0);
                    row.href = `/accounting/customer-billing/shipment-details/${row.id}`;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingCustomerBillingShipmentsTableService.js